import { createReducer } from 'app/utils/redux'

export default createReducer({}, {})
